import type { RouteLocation } from "vue-router";
import { useUser } from "@domain/Security";

/**
 * Controls the display of interrupt pages before allowing the user to access the Safety Center tab
 * @param to 
 * @param from 
 * @returns 
 */
export const DealerModeRouteGuard = async ( to: RouteLocation, from: RouteLocation ) =>
{
    const user = useUser();
    if( !user.isDealerMode )
    {
        return {
            path: '/my-garage',
            query: to.query
        }
    }
};